/**
 * 协议管理
 */
export default {
  protocolInfoselectProtocolInfoDetail: "/protocolInfo/selectProtocolInfoDetail", //   详情
  protocolInfoselectProtocolInfoList: "/protocolInfo/selectProtocolInfoList", //   列表
  protocolInfoupdateProtocolInfo: "/protocolInfo/updateProtocolInfo", //   修改
}
